import type { ContentDto, SeriesContentDto } from "$src/core/models/dto";

const isSeriesContent = (content: ContentDto): content is SeriesContentDto =>
  content.type === "series";

export default isSeriesContent;
